// extracted by css-extract-rspack-plugin
export default {"AuthorLink":"CommitAttribution-module__AuthorLink__aIRJ8fa","CommitAttributionContainer":"CommitAttribution-module__CommitAttributionContainer__VUvXEtE"};